import { useState } from 'react';
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.js';
import { recordPerformance } from '../api/quality.js';
import { ApiError } from '../api/client.js';

const FIELDS = [
  'qualityScoreDelta',
  'reworkCountDelta',
  'completionRateDelta',
  'reviewScoreDelta',
  'delayPctDelta',
  'compliancePctDelta',
] as const;

export function PainterPerformancePage(): ReactNode {
  const { id = '' } = useParams<{ id: string }>();
  const { token } = useAuth();
  const [form, setForm] = useState<Record<string, string>>(() => Object.fromEntries(FIELDS.map((k) => [k, '0'])));
  const [error, setError] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(): Promise<void> {
    setError(null); setMsg(null); setBusy(true);
    try {
      const body: Record<string, number> = {};
      for (const k of FIELDS) {
        const v = form[k];
        if (v !== '' && v !== undefined) body[k] = Number(v);
      }
      await recordPerformance(id, body, token);
      setMsg('Performance recorded');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Save failed');
    } finally { setBusy(false); }
  }

  return (
    <main aria-label="painter-performance">
      <h1>Painter performance — {id}</h1>
      {error ? <div role="alert">{error}</div> : null}
      {msg ? <div role="status">{msg}</div> : null}
      <form aria-label="perf-form" onSubmit={(e) => { e.preventDefault(); void submit(); }}>
        {FIELDS.map((k) => (
          <label key={k}>{k}
            <input aria-label={k} type="number" step="0.01"
              value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
          </label>
        ))}
        <button type="submit" disabled={busy}>Apply</button>
      </form>
    </main>
  );
}
